export default {
  product: {
    title: '产品',
    selfCustodyWallet: '手机钱包',
    selfCustodyWalletDesc: '您的移动端数字资产钱包，支持iOS和Android',
    hardwareWallet: '硬件钱包',
    hardwareWalletDesc: '拥有KeyPal，让您的资产更安全',
    extensionWallet: '插件钱包',
    extensionWalletDesc: '您电脑上更好用的钱包',
    transit: 'Transit',
    transitDesc: '多链聚合、跨链工具及NFT市场',
    fiveDegrees: '5Degrees',
    fiveDegreesDesc: 'Web3.0上的社交网络协议',
    stakeVault: '质押宝',
    stakeVaultDesc: '支持自托管质押节点和小额灵活质押节点',
  },
  project: {
    subDApp: '提交DApp',
    subToken: '提交代币',
    subNFT: '提交NFT',
    subChain: '提交公链',
  },
  assets: {
    title: '资产',
  },
  collaborations: {
    title: '项目合作',
  },
  community: {
    title: '社区',
    developers: '开发者',
    recruiting: 'TP侠',
  },
  helpCenter: {
    title: '帮助中心',
  },
  features: {
    title: '功能',
    buyCrypto: '购买加密资产',
    mobileWallet: '手机钱包',
    hardwareWallet: '硬件钱包',
    extensionWallet: '插件钱包',
    desktop: '桌面端钱包',
    fiveDegrees: '5Degrees',
    approvalDetector: '授权检测',
    tokenSecurity: '代币安全检测',
    keyGenerator: '私钥生成器',
    BATCH_SENDER: '批量转账',
  },
  information: {
    title: '信息',
    blockchainGuide: '区块链小白书',
    tronWallet: '波场小白书',
    iostWallet: 'IOST小白书',
    tpMan: 'TP侠',
  },
  developers: {
    title: '开发者',
    github: 'Github (TP-Lab)',
    devCenter: '开发者中心',
    subDApp: '提交DApp',
    subToken: '提交代币',
    subNFT: '提交NFT',
  },
  company: {
    title: '公司',
    about: '关于',
    careers: '招聘',
    pressKit: '品牌素材',
    swagShop: '周边商店',
  },
  support: {
    title: '支持',
    helpCenter: '帮助中心',
    contactUs: '联系我们',
  },
  legal: {
    title: '法律',
    privacyPolicy: '隐私政策',
    terms: '服务协议',
  },
  main: {
    title: '版本验证',
    language: '中文',
    intro:
      '版本验证通过匹配版本间的MD5或SHA256是否一致来判断您安装的TokenPocket是否为正版，请您务必通过官方渠道下载TokenPocket钱包，避免上当受骗。关于如何获取版本的MD5或SHA256，',
    tutorial: '请查看教程 >',
    system: '系统',
    android: '安卓',
    ios: '苹果',
    version: '版本号',
    allVersion: '全部版本',
    appChannel: 'App渠道',
    developer: '开发者',
    allChannel: '全部渠道',
    md5: '版本MD5',
    sha256: '版本SHA256',
    log: '版本日志',
    check: '点击查看',
    versionLog: '版本日志',
    confirm: '确定',
    aboutIOS: '关于iOS版本',
    IOSDesc:
      '由于iOS版本只有App Store一个下载渠道，App只有通过App Store下载的才能正常安装，因此在使用苹果相关设备时，请务必认证App Store唯一下载渠道。',
    IOSDesc_2:
      '2022年10月8日之前在App Store中下载的开发商为: TOKENPOCKET FOUNDATION LTD 是TokenPocket开发的早期版本，也是正版钱包可以正常的使用，后续将暂停更新服务。',
    aboutAndroid: '关于安卓版本',
    androidDesc: '当前TokenPocket提供安卓下载的渠道包括：官网、谷歌商店、三星应用商店、华为应用商店、OPPO应用商店、Vivo应用商店。由于个别应用商店在下载过程中无法获取到apk安装包，因此无法进行MD5或SHA256计算校验！所以，请您在下载的时候，务必核对清楚开发商信息，参照下方！',
    IOSAppName: 'App名称:',
    TPWallet: 'TP Wallet',
    AppIcon: 'App图标:',
    AppDeveloper: '官方开发者:',
    downloadLink: '下载链接:',
    copied: '已复制',
    versionVerification: '版本校验',
  },
  follow: {
    title: '关注我们',
    desc1: 'TokenPocket 客服不会私聊您！',
    desc2:
      '请注意，您即将进入TokenPocket社区，您进入社区可能会有人假冒TokenPocket的工作人员私聊您，请您务必警惕，所有私聊您的都可能是骗子！TokenPocket工作人员不会主动跟您私信！',
    desc3: '知道了，继续前往',
  },
};
